import { useState } from 'react';
import { ApiResponse_courseDTO, ApiResponse_string, DedicatedStatusClient } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';
import { handleHookError } from '../utils/hookUtils/handleHookError';

export const useDedicatedStatusApi = () => {
    const apiClient = new DedicatedStatusClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const generateCertificate = async (courseTypeId: string, itemId: string): Promise<string> => {
        setIsLoading(true);
        try {
            const response = await apiClient.generateDedicatedStatusCertificate(courseTypeId, itemId);

            if (response.success && response.data) {
                return response.data;
            } else {
                throw new Error(response.message || 'Failed to generate certificate');
            }
        } catch (err: unknown) {
            handleHookError(err, 'Error generating certificate', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const generateHtmlCertificate = async (courseTypeId: string, itemId: string): Promise<string> => {
        setIsLoading(true);
        try {
            const response = await apiClient.generateHtmlDedicatedStatusCertificate(courseTypeId, itemId);
            if (response.success && response.data) {
                return response.data;
            } else {
                throw new Error(response.message || 'Failed to generate HTML certificate');
            }
        } catch (err: unknown) {
            handleHookError(err, 'Error generating HTML certificate', setError);
            throw err;
        } finally {
            setIsLoading(false);
        }
    };

    const checkIsForfeited = async (id: string): Promise<boolean> => {
        try {
            const response = await (apiClient as any).checkDedicatedStatusIsForfeited(id);
            return response?.data === true;
        } catch {
            return false;
        }
    };

    return { generateCertificate, generateHtmlCertificate, checkIsForfeited, isLoading, error };
};